import React from 'react'
import {Icon} from 'react-onsenui'

// eslint-disable-next-line import/no-anonymous-default-export
export default ({navigator, text, custom}) => <div onClick={() => {
    if (navigator && navigator?.pages?.length > 1) {
        navigator.popPage()
    } else if (custom) {
        custom();
    } else {
        console.error("Back button with no navigator or custom")
    }
}}>
    <Icon
        style={{color: "#000000"}}
        size={{default: 20}}
        icon={{default: 'chevron-left'}}
    /> <span>{text}</span>
</div>